import { highlighters, V } from "@clientio/rappid";
import { ERROR_COLOR, MARKER } from "./base/validation";
import { moveEmbeddedRegionMarker } from "./base/utils";

export class ErrorsList extends highlighters.list {
  createListItem(tooltip: string, { width, height }: { width: number; height: number }) {
    const itemNode = V("text", {
      y: height,
      x: width,
      fill: ERROR_COLOR,
      draggable: false,
      cursor: "pointer",
      opacity: 1,
    });
    itemNode.node.setAttribute("font-family", "FontAwesome");
    itemNode.text(MARKER);
    itemNode.node.setAttribute("data-tooltip", tooltip);
    itemNode.node.setAttribute("font-size", "13px");
    itemNode.node.setAttribute("text-anchor", "middle");
    itemNode.node.setAttribute("xml:space", "preserve");
    return itemNode.node;
  }

  position() {
    moveEmbeddedRegionMarker(this);
  }
}
